import React, { createContext, useContext } from "react";
import useAuthenticationHook from "./useAuthentication.hook";
import { IUser } from "../../../authentication/contracts/IUser.interface";


// <1:1> create the context, this will now expose the functionalities of the hook to the caller
export const AuthenticationContext = createContext({} as IUser);

interface IProps {
  children: React.ReactNode
}
// <1:3> create the provider for the context
export const AuthenticationContextProvider = ({ children }: IProps) => {

  // NOTE: this is not directly exposed to the child components
  // we are exposing this object only through the context eg: const hookProps = useContext(<context_name>);
  const authenticationHook: IUser = useAuthenticationHook();


  return (
    <AuthenticationContext.Provider value={authenticationHook}>
      {children}
    </AuthenticationContext.Provider>
  );
}

// use useMuiThemeContext in client components to extract the theme hooks
const useAuthenticationContext = () => useContext(AuthenticationContext)
export default useAuthenticationContext;